/* Prop Types */
interface KeyDriversWrapperProps {
  description: string;
  children: React.ReactNode;
}

/*
 * KeyDriversWrapper component
 *
 * This component is a reusable wrapper for displaying key driver sections in the in-depth report.
 */
export const KeyDriversWrapper = ({ description, children }: KeyDriversWrapperProps) => {
  /* Render */
  return (
    <div className="p-4 rounded-lg bg-base-200 flex flex-col gap-3">
      <div>
        <p className="font-semibold pb-1.5">Key Drivers</p>
        <p className="text-xs text-base-content/70">{description}</p>
      </div>

      {children}
    </div>
  );
};
